import { Component, OnInit, ChangeDetectionStrategy, Input, AfterViewInit, Inject } from '@angular/core';
import { TrialEndedDialogService } from './trial-ended-dialog.service';
import { AnalyticsService } from '@mode/shared/util-segment';
import { Subscription, fromEvent } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  standalone: true,
  selector: 'mode-trial-ended-dialog-launcher',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialEndedDialogLauncherComponent implements OnInit, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() userId: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() userEmail: string;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() userDisplayName: string;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() workspaceId: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS2564
  @Input() workspaceUsername: string;

  pageEventSubscription: Subscription | undefined;

  constructor(
    private trialEndedDialog: TrialEndedDialogService,
    private analyticsService: AnalyticsService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit() {
    this.trialEndedDialog.open(this.userDisplayName, this.userEmail, true);
    // send event to segment
    this.analyticsService.run('track', 'UI Viewed', {
      location: 'Trial ended modal',
      workspaceId: this.workspaceId,
      workspaceUsername: this.workspaceUsername,
      userId: this.userId,
    });
  }

  ngAfterViewInit() {
    this.pageEventSubscription = fromEvent(this._document, 'mousemove').subscribe(() => {
      if (!this.trialEndedDialog.dialogPresentOnTheView()) {
        this.trialEndedDialog.open(this.userDisplayName, this.userEmail, true);
      }
    });
  }

  ngOnDestroy() {
    this.pageEventSubscription?.unsubscribe();
  }
}
